import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getInsuranceData } from "../../../../../store/Api";
import { setAppError, setBreadCrumb } from "../../../../../store/userSlice";
import FileUploadElement from "../../../../../ReusableComponents/UploadFile/uplaodFile";
import ListNewInsurance from "./ListNewInsurance";

export default function NewInsurance(props) {
  const Client = useSelector((state) => state.insuranceData);
  const dispatch = useDispatch();

  //screen Title Show fun
  const titleBorder = [{ label: "Insurance", link: "/dashboard/Insurance" }];
  useEffect(() => {
    dispatch(setBreadCrumb(titleBorder));
  }, []);

  const [loading, setLoading] = useState({
    updateData: false,
    uploadFile: false,
    listData: false,
    loadingId: "",
  });
  const token = localStorage.getItem("nodeToken");

  const url = 'employee-insurance/search?query';
  useEffect(() => {
    dispatch(getInsuranceData({ token, url }));
  }, []);

  const updateData = () => {
    dispatch(getInsuranceData({ token, url }));
  };

  const [showPromptElement, setShowPromptElement] = useState({
    open: false,
  });

  return (
    <ListNewInsurance
      list={Client}
      loading={loading}
      titles={[
        "S.NO.",
        "point of hire",
        "EFFECTIVE DATE",
        "NAME",
        "NATIONALITY",
        "STAFF ID",
        "CLIENT Name",
        "BORDER NO",
        "Iqama NO",
        "D.O.B",
        "RELATION",
        "GENDER",
        "MARITAL STATUS",
        "CLASS",
        "MOBILE NO",
        "HEAD OF FAMILY BUPA ID IF ADDING DEPENDENTS",
        "SPONSOR ID",
        "KSA ARRIVAL DATE",
        "HEALTH CONDITIONS IF ANY",
        "START FROM",
        "MEMBERSHIP NO",
        "STATUS",
        "POLICY NO",
        "INSURANCE COMPANY",
        "SPONSOR NAME",
        "REMARKS",
        "STATUS",
      ]}
      token={token}
      updateData={updateData}
      uploadFile={setShowPromptElement}
    />
  );
}
